import { _ } from "i18n";
import { GameHistorySubTabId, type GameHistorySubTab } from "./gameHistorySubTabConfig";

interface GameHistorySubTabsProps {
	subTab: GameHistorySubTab;
	onSubTabChange: (subTab: GameHistorySubTab) => void;
}

const SUB_TABS: { id: GameHistorySubTab; labelKey: Parameters<typeof _>[0] }[] = [
	{ id: GameHistorySubTabId.All, labelKey: "discover.gameDetail.history.subTab.all" },
	{ id: GameHistorySubTabId.InternalNotes, labelKey: "discover.gameDetail.history.subTab.internalNotes" },
	{ id: GameHistorySubTabId.Logs, labelKey: "discover.gameDetail.history.subTab.logs" },
];

export function GameHistorySubTabs({ subTab, onSubTabChange }: GameHistorySubTabsProps) {
	return (
		<div className="discoverGameHistory-headerBar">
			<span className="discoverGameHistory-headerTitle">{_("discover.gameDetail.history.title")}</span>
			<div className="discoverGameHistory-subTabs">
				{SUB_TABS.map(({ id, labelKey }) => (
					<button
						key={id}
						type="button"
						className={`discoverGameHistory-subTab ${subTab === id ? "discoverGameHistory-subTab--active" : ""}`}
						onClick={() => onSubTabChange(id)}
					>
						{_(labelKey)}
					</button>
				))}
			</div>
		</div>
	);
}
